import { auth } from "../firebase";
import {
  applyActionCode,
  checkActionCode,
  confirmPasswordReset,
  verifyPasswordResetCode,
} from "firebase/auth";

// ✅ Nur interne continueUrls erlauben
export const getSafeContinueUrl = (raw) => {
  if (!raw) return "";

  try {
    const u = new URL(raw, window.location.origin);

    if (u.origin === window.location.origin) {
      return `${u.pathname}${u.search}${u.hash}`;
    }

    return "";
  } catch (e) {
    if (typeof raw === "string" && raw.startsWith("/")) {
      return raw;
    }
    return "";
  }
};

export const getFriendlyAuthActionError = (error) => {
    const rawMessage = String(error?.message || error || "");

if (rawMessage.includes("weak-password-local")) {
  return {
    code: "weak-password-local",
    friendly:
      "Bitte ein Passwort mit mindestens 8 Zeichen, 1 Großbuchstaben, 1 Zahl und 1 Sonderzeichen eingeben.",
    raw: rawMessage,
  };
}
  const code = error?.code || "";
  let friendly = "Der Link ist ungültig oder abgelaufen.";

  if (code.includes("auth/invalid-action-code")) {
    friendly = "Der Link ist ungültig.";
  } else if (code.includes("auth/expired-action-code")) {
    friendly = "Der Link ist abgelaufen.";
  } else if (code.includes("auth/user-disabled")) {
    friendly = "Dieses Konto ist deaktiviert.";
  } else if (code.includes("auth/user-not-found")) {
    friendly = "Der Nutzer wurde nicht gefunden.";
  } else if (code.includes("auth/weak-password")) {
    friendly = "Das Passwort ist zu schwach.";
  }

  return {
    code,
    friendly,
    raw: String(error?.message || error || ""),
  };
};

export const executeAuthAction = async ({ mode, oobCode }) => {
  if (!mode || !oobCode) {
    throw new Error("missing-mode-or-oobCode");
  }

  if (mode === "verifyEmail") {
    await checkActionCode(auth, oobCode);
    await applyActionCode(auth, oobCode);

    try {
      if (auth.currentUser) {
        await auth.currentUser.reload();
      }
    } catch (e) {
      console.warn("auth.currentUser.reload() fehlgeschlagen:", e);
    }

    return {
      type: "verifyEmail",
      title: "✅ E-Mail bestätigt",
      message:
        "Danke! Deine E-Mail-Adresse wurde erfolgreich bestätigt. Du kannst dich jetzt einloggen.",
    };
  }

  if (mode === "resetPassword") {
    await verifyPasswordResetCode(auth, oobCode);

    return {
      type: "resetPassword",
      title: "Passwort zurücksetzen",
      message: "Bitte vergib ein neues Passwort.",
      resetReady: true,
    };
  }

  return {
    type: "unsupported",
    title: "Nicht unterstützte Aktion",
    message:
      "Diese Aktion wird aktuell nicht unterstützt. Bitte öffne die App erneut.",
  };
};

export const submitPasswordReset = async ({ oobCode, newPassword }) => {
  if (!oobCode) {
    throw new Error("missing-oobCode");
  }

  const passwordRequirements =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

if (!passwordRequirements.test(String(newPassword || ""))) {
  throw new Error("weak-password-local");
}

  await confirmPasswordReset(auth, oobCode, newPassword);

  return {
    title: "✅ Passwort geändert",
    message: "Dein Passwort wurde aktualisiert. Du kannst dich jetzt einloggen.",
  };
};